import { API } from "../../api";
async function apply_starshipit_rate(request) {
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/basket/apply/starshipit/rate`,
        content: request,
    });
}
export { apply_starshipit_rate };
